export default __webpack_public_path__ + "static/superbetter-design-web-05ee8caac8f8497e24c9dd024652fa3a.webp";